var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoyality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_5166_5056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4811 9.30707C17.4813 9.30932 17.4809 9.31154 17.4811 9.31383C17.4815 9.31545 17.4821 9.31687 17.4823 9.31853L17.8863 12.1049C17.8884 12.1192 17.8879 12.1337 17.8862 12.1479L18.2569 11.2378L18.2576 8.7877C18.1502 8.69449 18.0187 8.65149 17.8898 8.67038C17.6245 8.70884 17.4411 8.9945 17.4811 9.30707Z",
    fill: "url(#paint0_linear_5166_5056)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7879 10.1429L17.0959 12.2676C17.2399 12.2834 17.3726 12.3322 17.4842 12.4088L17.5552 12.1217L17.175 9.49902C16.9157 9.54985 16.7429 9.8331 16.7879 10.1429Z",
    fill: "url(#paint1_linear_5166_5056)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0826 7.87109C18.8088 7.87109 18.586 8.13244 18.586 8.45371L18.586 8.7147C18.586 8.71533 18.5862 8.71596 18.5862 8.71668L18.5855 11.2695C18.5855 11.2909 18.5813 11.312 18.5733 11.3317L17.7549 13.3407C17.7539 13.3432 17.7525 13.3453 17.7514 13.3478C17.6698 13.5506 17.516 13.7214 17.316 13.8301L15.7187 14.9569C15.6898 14.9773 15.6566 14.9871 15.6238 14.9871C15.572 14.9871 15.521 14.9627 15.4889 14.9172C15.4364 14.8428 15.4542 14.7399 15.5286 14.6874L17.1341 13.5548C17.1398 13.5508 17.1458 13.5472 17.152 13.5439C17.2899 13.4708 17.3951 13.3553 17.4483 13.2187C17.4486 13.2178 17.4491 13.2172 17.4495 13.2163H17.4494L17.4503 13.2144C17.5006 13.0816 17.4952 12.9461 17.4349 12.8324C17.3505 12.6729 17.1692 12.5798 16.9624 12.59C16.9615 12.59 16.9608 12.5904 16.9599 12.5904C16.8647 12.5953 16.773 12.6207 16.6873 12.6661C16.6661 12.6772 14.6365 13.7413 14.1481 14.2818C13.8219 14.6428 13.3505 15.5773 13.2475 16.0673C13.1809 16.3836 13.3541 17.5031 13.5327 18.4784L16.6612 18.4784L16.6975 18.0398C16.6997 18.013 16.7084 17.9872 16.7229 17.9647L18.7742 14.7522L19.5784 12.1579L19.579 8.4541C19.579 8.13276 19.3563 7.87117 19.0826 7.87109Z",
    fill: "url(#paint2_linear_5166_5056)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1388 18.8086C13.0093 18.8086 12.9039 18.914 12.9038 19.0434L12.9038 20.0026C12.9038 20.0649 12.9284 20.1237 12.9729 20.1684C13.0175 20.2129 13.0763 20.2375 13.1386 20.2375H17.2863C17.4158 20.2375 17.5212 20.1321 17.5212 20.0025V19.0436C17.5212 18.9812 17.4967 18.9224 17.4521 18.8778C17.4075 18.8333 17.3487 18.8087 17.2864 18.8087L13.1388 18.8086ZM16.6703 20.1739C16.3114 20.1739 16.0195 19.8819 16.0195 19.5231C16.0195 19.1642 16.3114 18.8722 16.6703 18.8722C17.0291 18.8722 17.3211 19.1642 17.3211 19.5231C17.3211 19.8819 17.0291 20.1739 16.6703 20.1739Z",
    fill: "url(#paint3_linear_5166_5056)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.06339 9.49902L2.68311 12.1217L2.75409 12.4087C2.86568 12.3321 2.99848 12.2832 3.14244 12.2674L3.4505 10.1429C3.49545 9.8331 3.3228 9.54993 3.06339 9.49902Z",
    fill: "url(#paint4_linear_5166_5056)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98887 16.0673C6.88587 15.5773 6.41452 14.6429 6.08827 14.2818C5.59965 13.7411 3.57022 12.6772 3.54979 12.6666C3.4633 12.6208 3.3716 12.5953 3.27638 12.5904C3.27555 12.5904 3.27484 12.5901 3.27401 12.59C3.06717 12.5803 2.88587 12.6729 2.80144 12.8324C2.74065 12.9471 2.73575 13.0838 2.78741 13.2174C2.7876 13.2179 2.78788 13.2183 2.78804 13.2187C2.8412 13.3553 2.94642 13.4708 3.08437 13.5439C3.09057 13.5472 3.0965 13.5508 3.10223 13.5548L4.70774 14.6874C4.78213 14.7399 4.79992 14.8428 4.74743 14.9172C4.71529 14.9627 4.6643 14.9871 4.61256 14.9871C4.57972 14.9871 4.54656 14.9773 4.51766 14.9569L2.92033 13.8301C2.71986 13.7211 2.56578 13.5498 2.48432 13.3464C2.48345 13.3444 2.4823 13.3427 2.48147 13.3407L2.48045 13.3382C2.48009 13.3373 2.4797 13.3364 2.47934 13.3355L1.66301 11.3317C1.65498 11.312 1.65083 11.2909 1.65083 11.2695L1.65016 8.71668C1.65016 8.71596 1.65036 8.71533 1.65036 8.7147L1.65028 8.45375C1.65028 8.13244 1.42751 7.87109 1.15371 7.87109C0.879956 7.87121 0.657266 8.13276 0.657227 8.4541L0.657859 12.1578L1.46202 14.7521L3.51334 17.9646C3.52781 17.9872 3.53647 18.013 3.53872 18.0397L3.57504 18.4784L6.70354 18.4783C6.88227 17.5031 7.0554 16.3836 6.98887 16.0673Z",
    fill: "url(#paint5_linear_5166_5056)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34773 8.67036C2.21911 8.65154 2.08737 8.69447 1.97998 8.78771L1.98061 11.2378L2.35137 12.148C2.34967 12.1337 2.34915 12.1192 2.35125 12.1049L2.75525 9.31851C2.75548 9.31689 2.75612 9.31542 2.75643 9.3138C2.75663 9.31151 2.75623 9.3093 2.75651 9.30704C2.79651 8.99447 2.61311 8.70882 2.34773 8.67036Z",
    fill: "url(#paint6_linear_5166_5056)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09689 20.2375C7.15918 20.2375 7.21804 20.2129 7.26262 20.1684C7.30721 20.1237 7.33175 20.0649 7.33175 20.0026L7.33168 19.0434C7.33168 18.914 7.22626 18.8086 7.09677 18.8086L2.94918 18.8087C2.88689 18.8087 2.82803 18.8333 2.78345 18.8778C2.73886 18.9224 2.71432 18.9812 2.71436 19.0435V20.0026C2.71436 20.1321 2.81977 20.2375 2.9493 20.2375H7.09689ZM3.56523 18.8722C3.92413 18.8722 4.21607 19.1642 4.21607 19.5231C4.21607 19.8819 3.92409 20.1739 3.56523 20.1739C3.20638 20.1739 2.91444 19.8819 2.91444 19.5231C2.91444 19.1642 3.20638 18.8722 3.56523 18.8722Z",
    fill: "url(#paint7_linear_5166_5056)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0879 15.7617C11.87 15.5438 11.5774 15.4238 11.2642 15.4238C10.9434 15.4238 10.6418 15.5488 10.4149 15.7756L10.2353 15.9552C10.2044 15.9861 10.1625 16.0035 10.1187 16.0035C10.075 16.0035 10.033 15.9862 10.0021 15.9552L9.82249 15.7756C9.59561 15.5487 9.29394 15.4238 8.97315 15.4238C8.65991 15.4238 8.36733 15.5438 8.14943 15.7617C7.92923 15.982 7.80922 16.2776 7.81156 16.5942C7.81389 16.9117 7.93883 17.2103 8.16338 17.4348L10.1187 19.3901L12.074 17.4348C12.2986 17.2102 12.4235 16.9117 12.4258 16.5942C12.4281 16.2776 12.3081 15.982 12.0879 15.7617Z",
    fill: "url(#paint8_linear_5166_5056)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6455 1.06768L10.1185 0L9.59153 1.06768C9.56753 1.11634 9.52109 1.15009 9.46737 1.15784L8.28906 1.3291L9.14168 2.16022C9.18053 2.19809 9.19828 2.25271 9.18911 2.30611L8.98784 3.47964L10.0417 2.92556C10.0657 2.91292 10.0921 2.90663 10.1184 2.90663C10.1448 2.90663 10.1711 2.91292 10.1952 2.92556L11.2491 3.47964L11.0478 2.30611C11.0386 2.25267 11.0563 2.19809 11.0952 2.16022L11.9478 1.3291L10.7695 1.15784C10.7159 1.15009 10.6694 1.11634 10.6455 1.06768Z",
    fill: "url(#paint9_linear_5166_5056)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8035 3.27452L14.3996 2.45605L13.9956 3.27452C13.9716 3.32314 13.9252 3.35689 13.8715 3.36468L12.9683 3.49591L13.6219 4.13299C13.6607 4.17089 13.6785 4.22548 13.6693 4.27892L13.515 5.17841L14.3229 4.75375C14.3469 4.74118 14.3732 4.73481 14.3996 4.73481C14.4259 4.73481 14.4523 4.74114 14.4763 4.75375L15.2842 5.17841L15.1299 4.27892C15.1207 4.22544 15.1384 4.17089 15.1773 4.13299L15.8309 3.49591L14.9277 3.36468C14.8739 3.35689 14.8275 3.32318 14.8035 3.27452Z",
    fill: "url(#paint10_linear_5166_5056)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05933 4.13303C5.09818 4.17093 5.11593 4.22552 5.10676 4.27896L4.95245 5.17845L5.76032 4.75379C5.80835 4.72857 5.86574 4.72857 5.91376 4.75379L6.7216 5.17845L6.56733 4.27896C6.55816 4.22548 6.5759 4.17093 6.61476 4.13303L7.26836 3.49595L6.36515 3.36472C6.31143 3.35693 6.26503 3.32318 6.241 3.27456L5.83704 2.45605L5.43312 3.27452C5.40909 3.32314 5.36269 3.35689 5.30897 3.36468L4.40576 3.49591L5.05933 4.13303Z",
    fill: "url(#paint11_linear_5166_5056)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73881 12.7236L6.81842 12.4363C7.05593 11.4986 8.04001 10.7329 9.01117 10.7329H9.01975C9.07473 10.7329 9.12607 10.7603 9.15667 10.806L10.1189 12.2412L11.0812 10.806C11.1117 10.7604 11.1631 10.7329 11.2181 10.7329H11.2259C12.1974 10.7329 13.1818 11.4986 13.4203 12.4399L13.4987 12.7242C14.1323 11.9477 14.4785 10.9806 14.4785 9.97094C14.4785 7.56708 12.5228 5.61133 10.1189 5.61133C7.71499 5.61133 5.75928 7.56704 5.75928 9.97094C5.75928 10.9816 6.10533 11.9485 6.73881 12.7236ZM10.1188 6.16774C11.1982 6.16774 11.8173 6.81091 11.8173 7.93238C11.8173 8.53191 11.6418 9.20797 11.3476 9.7409C11.0108 10.3512 10.5744 10.6872 10.1188 10.6872C9.66315 10.6872 9.22671 10.3512 8.8899 9.7409C8.59579 9.20801 8.42017 8.53187 8.42017 7.93238C8.42014 6.81095 9.03927 6.16774 10.1188 6.16774Z",
    fill: "url(#paint12_linear_5166_5056)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.237 13.0159L13.1011 12.5231C12.9064 11.7548 12.0959 11.1046 11.3043 11.0636L10.2554 12.6278C10.2248 12.6735 10.1734 12.7009 10.1184 12.7009C10.0635 12.7009 10.0121 12.6735 9.98148 12.6278L8.93261 11.0635C8.12897 11.1027 7.33402 11.7409 7.13671 12.5197L6.99951 13.0148C7.81592 13.8518 8.94613 14.3295 10.1184 14.3295C11.2896 14.3295 12.4198 13.852 13.237 13.0159Z",
    fill: "url(#paint13_linear_5166_5056)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5166_5056",
    x1: 17.8666,
    y1: 8.66602,
    x2: 17.8666,
    y2: 12.1479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5166_5056",
    x1: 17.168,
    y1: 9.49902,
    x2: 17.168,
    y2: 12.4088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5166_5056",
    x1: 16.406,
    y1: 7.87109,
    x2: 16.406,
    y2: 18.4784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5166_5056",
    x1: 15.2125,
    y1: 18.8086,
    x2: 15.2125,
    y2: 20.2375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5166_5056",
    x1: 3.07036,
    y1: 9.49902,
    x2: 3.07036,
    y2: 12.4087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5166_5056",
    x1: 3.83032,
    y1: 7.87109,
    x2: 3.83032,
    y2: 18.4784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5166_5056",
    x1: 2.37098,
    y1: 8.66602,
    x2: 2.37098,
    y2: 12.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5166_5056",
    x1: 5.02306,
    y1: 18.8086,
    x2: 5.02306,
    y2: 20.2375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5166_5056",
    x1: 10.1187,
    y1: 15.4238,
    x2: 10.1187,
    y2: 19.3901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5166_5056",
    x1: 10.1184,
    y1: 0,
    x2: 10.1184,
    y2: 3.47964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5166_5056",
    x1: 14.3996,
    y1: 2.45605,
    x2: 14.3996,
    y2: 5.17841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5166_5056",
    x1: 5.83706,
    y1: 2.45605,
    x2: 5.83706,
    y2: 5.17845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5166_5056",
    x1: 10.1189,
    y1: 5.61133,
    x2: 10.1189,
    y2: 12.7242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5166_5056",
    x1: 10.1182,
    y1: 11.0635,
    x2: 10.1182,
    y2: 14.3295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5166_5056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2374,
    height: 20.2374,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyality);
export default __webpack_public_path__ + "static/media/loyality.a7494ffcd79ac2cf36028e3b5cffc4d8.svg";
export { ForwardRef as ReactComponent };